export const createCertificationStepScoresheetsRequests = (client) => ({
    putCertificationStepScoresheetScore: async (payload) => {
        const { data } = await client.api.request({
            type: "certification_step_scoresheets",
            url: `/certification_step_scoresheets/${payload?.id}`,
            body: payload,
            method: "PUT",
        });
        return { data };
    },
});
//# sourceMappingURL=index.js.map